var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "support-4iQ" },
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-app",
        { staticClass: "support-4iq-form" },
        [
          _c(
            "v-card",
            {
              staticClass: "mx-auto",
              attrs: { "max-width": "600" },
              model: {
                value: _vm.showSupport4iQPopup,
                callback: function($$v) {
                  _vm.showSupport4iQPopup = $$v
                },
                expression: "showSupport4iQPopup"
              }
            },
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "user_creation_popup_div" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-0" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "" } }, [
                                _c(
                                  "span",
                                  { staticClass: "headline indigo--text" },
                                  [_vm._v("Constella support")]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "pt-0" },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c("p", [
                                      _vm._v(
                                        "Thank you for contacting Constella Support!"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Please let us know how we can help you by providing us some details on the issue or question you have."
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          id: "supportEmail",
                                          label: "Email Address*",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.validDetails,
                                            _vm.rules.validEmail
                                          ]
                                        },
                                        on: {
                                          keydown: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                          }
                                        },
                                        model: {
                                          value: _vm.email,
                                          callback: function($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          id: "supportName",
                                          label: "Name*",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.validDetails
                                          ]
                                        },
                                        on: {
                                          keydown: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                          }
                                        },
                                        model: {
                                          value: _vm.name,
                                          callback: function($$v) {
                                            _vm.name = $$v
                                          },
                                          expression: "name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          id: "supportPhone",
                                          label: "Phone",
                                          rules: [_vm.rules.mobilemin]
                                        },
                                        on: {
                                          keydown: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                          }
                                        },
                                        model: {
                                          value: _vm.phone,
                                          callback: function($$v) {
                                            _vm.phone = $$v
                                          },
                                          expression: "phone"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          id: "supportMessage",
                                          label: "Message*",
                                          "no-resize": "",
                                          rows: "5",
                                          rules: [
                                            _vm.rules.required,
                                            _vm.rules.validDetails
                                          ]
                                        },
                                        on: {
                                          keydown: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                          }
                                        },
                                        model: {
                                          value: _vm.message,
                                          callback: function($$v) {
                                            _vm.message = $$v
                                          },
                                          expression: "message"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.getSupport4iqLocation &&
                                  _vm.captchaSiteKey
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("vue-recaptcha", {
                                            ref: "recaptcha",
                                            staticClass: "vueRecaptcha",
                                            attrs: {
                                              sitekey: _vm.captchaSiteKey
                                            },
                                            on: {
                                              verify: _vm.onCaptchaVerified,
                                              expired: _vm.onCaptchaExpired
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              class:
                                _vm.valid &&
                                (_vm.getSupport4iqLocation
                                  ? _vm.storeCaptchaToken != null
                                  : true)
                                  ? ""
                                  : "disabled",
                              attrs: {
                                depressed: "",
                                color: "grey lighten-3",
                                tabindex:
                                  _vm.valid &&
                                  (_vm.getSupport4iqLocation
                                    ? _vm.storeCaptchaToken != null
                                    : true)
                                    ? ""
                                    : -1,
                                type: "submit",
                                id: "submitForm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submit4iqSupportForm()
                                }
                              }
                            },
                            [_vm._v("Submit")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                depressed: "",
                                color: "grey lighten-3",
                                id: "cancelForm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closePopup()
                                }
                              }
                            },
                            [_vm._v("cancel")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }